var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBuyers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_786_19037)",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 11.012c.38.38-.106.472 1.392 1.372M8 11.012c-.182.365-.786.813-1.5 1.24m0 0c-.854.51-1.865.99-2.5 1.263-3 1.502-3 6.507-3 8.51h5m.5-9.773s1.494 2.799 3.5 2.765c1.94-.033 3.392-2.633 3.392-2.633m0 0c.474.284 1.647.65 2.608 1.131 1.484.743 1.978 1.537 2.359 3.016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.615 22.025V19.02",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 1,
    width: 8,
    height: 10.013,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4.107c.259.967 4.191 3.316 8.359 0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 17,
    width: 10,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.73 4.004h4",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_786_19037"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v23H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuyers);
export default __webpack_public_path__ + "static/media/icon-buyers.3619b368652ac9918bdd52b9cae3fd6b.svg";
export { ForwardRef as ReactComponent };